import React from 'react';
import acllogo2 from "../images/ACL-Logo2.png"
import aoalogo from "../images/AOA-white.png"
import hhslogo from "../images/HHS_logo.png"


const Footer = () => (

  
  
<div>
  <div class="grid  w-full" tabindex="0" style={{  backgroundColor: "#081222", color: "white" }}>
 

  <div className="flex px-8 pb-4 grid  w-full  grid-cols-1 sm:grid-cols-6 gap-2">
    <div class="pt-4 col-start-1 col-span-2"><div>
            <strong>ACL MISSION</strong>
            <p style={{fontSize:14+"px" }}>All people, regardless of age or disability, should be able to live independently and participate fully in their communities, and have the right to make choices and control the decisions in and about their lives. <a className ="footer-link" style={{ color: "white" }} href="https://acl.gov/" target="_blank"><u>Learn more about community living</u></a></p>
         </div></div>
    <div class="col-span-1"><div style={{ float: "left", padding: 10 + 'px' }}>
            <strong>SITE SUPPORT</strong>
            <ul style={{ listStyleType: "none"}}>
               <li><a className ="footer-link text-white" style={{ color: "white", fontSize:14+"px" }} href="mailto:tbi@acl.hhs.gov">Contact Us</a></li>
               <li><a className ="footer-link" style={{ color: "white", fontSize:14+"px" }}  href="https://www.acl.gov/node/445" target="_blank">Privacy Notice</a></li>
               <li><a className ="footer-link" style={{ color: "white", fontSize:14+"px" }}  href="https://www.acl.gov/node/444" target="_blank">Accessibility</a></li>
               <li><a className ="footer-link" style={{ color: "white" , fontSize:14+"px" }} href="https://www.hhs.gov/plugins.html" target="_blank">Viewers &amp; Players</a></li>
               <li><a className ="footer-link" style={{ color: "white", fontSize:14+"px" }}  href="https://www.acl.gov/node/446" target="_blank">Disclaimers</a></li>
            </ul>
         </div></div>
    <div class="col-span-1"> <div style={{ float: "left", padding: 10 + 'px' }}>
            <strong>RESOURCES</strong>
            <ul style={{ listStyleType: "none" }}>
               <li><a className ="footer-link" style={{ color: "white" , fontSize:14+"px" }} href="https://www.acl.gov/node/447" target="_blank">FOIA</a></li>
               <li><a className ="footer-link" style={{ color: "white", fontSize:14+"px" }}   href="https://www.hhs.gov/open/plain-writing/index.html" target="_blank">Plain Writing</a></li>
               <li><a className ="footer-link" style={{ color: "white", fontSize:14+"px" }}  href="https://www.hhs.gov/about/agencies/asa/eeo/resources/no-fear-act/index.html" target="_blank">No Fear Act</a></li>
            </ul>
         </div></div>
    <div class="col-span-1"><div style={{ float: "left",  padding: 10 + 'px' }}>
            <strong>PARTNER SITES</strong>
            <ul style={{ listStyleType: "none" }}>
               <li><a className ="footer-link" style={{ color: "white", fontSize:14+"px" }}  href="https://www.acl.gov/" target="_blank">ACL.gov</a></li>
               <li><a className ="footer-link" style={{ color: "white", fontSize:14+"px" }}  href="https://www.hhs.gov/" target="_blank">HHS.gov</a></li>
               <li><a className ="footer-link" style={{ color: "white", fontSize:14+"px" }}  href="https://www.usa.gov/" target="_blank">USA.gov</a></li>
               <li><a className ="footer-link" style={{ color: "white", fontSize:14+"px" }}  href="https://www.grants.gov/" target="_blank">Grants.gov</a></li>
               <li><a className ="footer-link" style={{ color: "white", fontSize:14+"px" }}  href="https://www.whitehouse.gov/" target="_blank">Whitehouse.gov</a></li>
            </ul>
         </div></div>
         
         
            <div  class="col-span-1 pt-2" style={{display:"inline"}}>
               
               <a href="http://acl.gov/" target="_blank"><img  style={{width:"100px"}}    src={acllogo2} class="fr-fic fr-dii" alt="ACL Logo"/></a>
           
            <a href="https://acl.gov/about-acl/administration-aging" target="_blank"><img   style={{width:"100px"}}  src={aoalogo} class="fr-fic fr-dii" alt="AoA Logo"/></a><hr style={{border:"solid", borderWidth:1+"px"}} />
            </div>
  </div>

      <div class ="grid px-8 w-full" style={{ display: "table", clear: "both", width: 100 + '%', paddingBottom: 0 + 'px', backgroundColor: "#182944", color: "white" , marginLeft:0+"px"}}>
         <div  class="flex grid px-8 w-full  grid-cols-1 sm:grid-cols-9 gap-2" style={{ width: 100 + "%", bottom: 0 + "px", backgroundColor: "#182944", color: "white" }}>
            <div  class="col-span-1" style={{ float: "left", padding: 10 + "px" ,  paddingLeft:30+"px"}}><a className ="footer-link" style={{ color: "white", fontSize:14+"px" }}  href="https://www.hhs.gov" target="_blank"><img src={hhslogo} alt ="HHS Logo" style={{ width: 50 + "px", padding: 5 + "px" }} class="fr-fic fr-dii" /></a></div>
            <div class="col-start-2 col-span-9">
            <div style={{ float: "left", width: 80 + "%", paddingTop: 10 + "px" , fontSize:14+"px" }}><a className ="footer-link" style={{ color: "white", fontSize:14+"px" }} className ="footer-link"  href="https://www.hhs.gov" target="_blank">U.S. Department of Health and Human Services</a>, <a className ="footer-link" href="https://acl.gov" style={{color:"white"}}>Administration for Community Living</a></div>
            <div style={{ float: "left", width: 80 + "%", paddingTop: 5 + "px" , fontSize:14+"px" }}><em>Advancing independence, integration, and inclusion throughout life</em></div>
         </div>
         </div>
      </div>

   </div>
   </div>
  
   
)

export default Footer